import { Component,
         OnInit }                   from '@angular/core';
import { MatDialog, MatSnackBarConfig }                from '@angular/material';
import { MatDialogRef }             from '@angular/material';
import { Globals }                  from './../common/globals';
import { ProductModel,
         TnProductAttribute,
         ProductLimitedSlot}       from './product.model';
import { SavingDialogComponent }    from './../common/saving-dialog.component';
import { ProductService }           from './../shared/product.service';
import { UploadService }            from './../shared/upload.service';
import { MatSnackBar }              from '@angular/material';
import { PortalTypeEnum } from '../login/login.model';
import { TrainClassService } from '../shared/train-class.service';
import { SortableFilter } from '../common/sortable-filter';
import { SettingService } from '../shared/setting.service';

@Component({
  selector: 'sa-product-dialog',
  template: require('./product-dialog.component.html'),
  styles: [require('./product-dialog.component.scss')]
})
export class ProductDialogComponent implements OnInit {
  public model: ProductModel;
  public imgUrl: string;
  public hasNewImage: boolean;
  public onImageTab: boolean;
  public onOtherTab: boolean;
  public onTextsTab: boolean;
  public customerOrderGroups = [
    {id: '1', groupName: 'Studené nápoje'},
    {id: '2', groupName: 'Pivo/víno'},
    {id: '3', groupName: 'Snacky'},
    {id: '4', groupName: 'Teplé nápoje'},
    {id: '5', groupName: 'Deserty'},
    {id: '6', groupName: 'Croissanty'},
    {id: '7', groupName: 'Saláty'},
    {id: '8', groupName: 'Sushi'},
    {id: '9', groupName: 'Ostatní'},
    {id: '10', groupName: 'Teplá jídla'}];
  // public customerClasses = [
  //   {id: 0, groupName: 'Relax'},
  //   {id: 1, groupName: 'Business'},
  //   {id: 2, groupName: 'Astra'},
  //   {id: 3, groupName: 'Lehátkové a lůžkové vozy'},
  //   {id: 4, groupName: 'Standard'},
  //   {id: 5, groupName: 'Low cost'},
  //   {id: 6, groupName: '1. třída'},
  //   {id: 7, groupName: '2. třída'}
  // ];

  public customerClasses = [];

  public slots = [];

  public slotsUpdated = false;

  public language: string = 'cs-CZ';
  public localizableAttributes: string[] = [];
  public languages = []; // fallback, by default loaded from setting, key supportedLanguages

  public locAttributes = () => this.model.localizedAttributes[this.language];

  public locAttributesNames = () => Object.keys(this.locAttributes());

  public locAttribute = (name) => this.locAttributes()[name];

  public getDescription = () => {
    var pd = this.model.productDescriptions.find(pd => pd.languageISOCode === this.language);
    return !!pd ? pd.description : '';
  };

  public getName = (item) => {
    switch (item) {
      case 'composition':
        return 'Složení';
      case 'description':
        return 'Popis';
      case 'detailedDescription':
        return 'Detailní popis';
      default:
        return item;
    }
  }

  constructor(public dialogRef: MatDialogRef<ProductDialogComponent>,
              public globals: Globals,
              private dialog: MatDialog,
              private snackbar: MatSnackBar,
              private uploadService: UploadService,
              private apiService: ProductService,
              private classService: TrainClassService,
              private settingsService: SettingService ) {

    this.onImageTab = false;
    this.onOtherTab = false;
    // this.onTextsTab = false;
    this.hasNewImage = false;
  }

  public classIsChecked(trainClass: any): boolean {
    return this.model.trainClasses.length > 0 && this.model.trainClasses.indexOf(trainClass.trainClassID) > -1;
  }

  getBusinessType(m: ProductModel) {
    if (m.businessType === PortalTypeEnum.Bus) {
            return 'BUS';
        } else {
            return 'VLAK';
        }
    }

  public selectChange($event: any) {
    console.log($event, $event.tab, this);

    this.onImageTab, this.onOtherTab, this.onTextsTab = false;

    this.onImageTab = $event.index === 1;
    this.onOtherTab = $event.index === 2;
    // this.onTextsTab = $event.index === 7;
  }

  ngOnInit() {

    // let allowedLanguagesFilter: SortableFilter = { searchString: 'supportedLanguages' } as SortableFilter;
    // this.settingsService.getItems(allowedLanguagesFilter)
    //                         .subscribe(langs => {
    //                           if(!!langs && langs.length > 0) {
    //                             this.languages = langs[0].value.split(',');
    //                           }
    //                         });

    this.languages = Object.keys(this.model.localizedAttributes);

    this.apiService.getSlots().subscribe(s => {
      this.slots = s.map(sl => {
        let pls = new ProductLimitedSlot();
        pls.slotID = sl.slotID;
        pls.name = sl.name;
        // tslint:disable-next-line: no-unused-expression
        pls.selected = !!this.model.productLimitedSlots.find(pl => pl.slotID === sl.slotID);
        return pls;
      }).sort((a, b) => a.slotID - b.slotID);
    });

    this.classService.getItems(null).subscribe(cs => this.customerClasses = cs);

    this.getImageUrl(false);
  }

  getImageUrl(tmp: boolean) {
    this.imgUrl = this.globals.GetUrlPrefix() +
                  '/api/product/getimage/' +
                  this.model.recUID +
                  '?anticache=' +
                  new Date().getTime() +
                  '&cached=' +
                  (tmp ? 'true' : 'false');
  }

  keepOriginal() {
    this.getImageUrl(false);
    this.hasNewImage = false;
  }

  removeImage() {
    let cloakRef = this.dialog.open(SavingDialogComponent);
    let snack = this.snackbar;
    let saveRequest = this.apiService.updateItem(this.model.recUID, {});

    saveRequest.subscribe(
      res => {
        this.hasNewImage = false;
        this.model.hasImage = false;
        this.model.imagePath = '';
        snack.open('Obrázek byl odstraněn.', '', {duration: 2000});
      },
      error => {
        snack.open('Při zápisu změn se vyskytla chyba.', 'Zavřít');
      },
      () => {
        cloakRef.close();
      });
    }

  public uploadImage(file) {

    let cloakRef = this.dialog.open(SavingDialogComponent);
    let snack = this.snackbar;

    if (file!!) {
        let imgRequest = this.uploadService.makeFileRequest('/api/product/uploadimage/' + this.model.recUID, [], [file]);

        imgRequest.subscribe(
          res => {
              this.hasNewImage = true;
              snack.open('Obrázek byl nahrán na server.', '', {duration: 2000});
              this.getImageUrl(true);
          },
          error => {
              snack.open('Při nahrávání obrázku se vyskytla chyba.', 'Zavřít');
          },
          () => {
            cloakRef.close();
          });
    }
  }

  saveUploaded() {
    let cloakRef = this.dialog.open(SavingDialogComponent);
    let snack = this.snackbar;
    let saveRequest = this.apiService.saveImage(this.model.recUID);

    saveRequest.subscribe(
      res => {
        this.hasNewImage = false;
        this.model.hasImage = true;
        this.model.imagePath = this.model.recUID;
        snack.open('Obrázek byl uložen.', '', {duration: 2000});
        this.getImageUrl(false);
      },
      error => {
        snack.open('Při ukládání obrázku se vyskytla chyba.', 'Zavřít');
      },
      () => {
        cloakRef.close();
      });
  }

  isTrain() {
    return this.globals.portalType === PortalTypeEnum.Train;
  }

  slotUpdated() {
    this.slotsUpdated = true;
  }

  upsertProductAttribute(attrName: string, sendText: number) {
    let tnProductAttr = new TnProductAttribute();
    tnProductAttr.Name = attrName;
    tnProductAttr.ProductRecID = this.model.recID;
    tnProductAttr.Value = sendText.toString();
    tnProductAttr.Product = new ProductModel();

    let cloakRef = this.dialog.open(SavingDialogComponent);
    let snack = this.snackbar;
    let saveRequest = this.apiService.upsertItem('upsertattribute', tnProductAttr);

    saveRequest.subscribe(
      res => {
        snack.open('Atribut změněn.', '', {duration: 2000});
      },
      error => {
        snack.open('Při zápisu změn se vyskytla chyba.', 'Zavřít');
      },
      () => {
        cloakRef.close();
      });

    console.log(sendText);
  }

  upsertSlots() {
    if (!this.slotsUpdated) {
      return;
    }

    let slotsSelected = this.slots.filter(s => s.selected);

    this.apiService.updateSlots(this.model.recID.toString(), slotsSelected)
                   .subscribe(s => {
                     this.snackbar.open('Sloty aktualizovány', '', {duration: 2000} );
                   });
  }

  upsertProductAttributes(attrName: string[], sendText: number[]) {

    let tnProductAttrs = new Array<TnProductAttribute>();
    let counter = 0;
    for (let iName of attrName) {
      if (sendText[counter] != null) {
        tnProductAttrs.push(new TnProductAttribute(
                                      this.model.recID,
                                      iName,
                                      sendText[counter].toString(),
                                      new ProductModel()
        ));
      }
      counter++;
    };

    let cloakRef = this.dialog.open(SavingDialogComponent);
    let snack = this.snackbar;
    let saveRequest = this.apiService.upsertItem('upsertattributes', tnProductAttrs);

    saveRequest.subscribe(
      res => {
        snack.open('Atribut změněn.', '', {duration: 2000});
      },
      error => {
        snack.open('Při zápisu změn se vyskytla chyba.', 'Zavřít');
      },
      () => {
        cloakRef.close();
      });
      // this.dialogRef.close('save');
    // console.log(sendText);
  }

  toggleCustomerClass(trainClass: any) {
    let ix = this.model.trainClasses.indexOf(trainClass.trainClassID, 0);
    if (ix > -1) {
      this.model.trainClasses.splice(ix, 1);
    } else {
      this.model.trainClasses.push(trainClass.trainClassID);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/product-dialog/product-dialog.component.ts